"use strict";

exports.__esModule = true;
exports.default = upperFirst;

/**
 * @param {string} str
 */
function upperFirst(str) {
  if (typeof str !== 'string') {
    str = String(str);
  }

  return str.charAt(0).toUpperCase() + str.slice(1);
}


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/utils/upper-first.js
// module id = 184
// module chunks = 0